export enum ActivityStatus {
  NoActivity,
  Loading,
  Loaded,
  LoadFailed
}


// WEBPACK FOOTER //
// ./src/common/enums/activity-status.enum.ts